import React, { useEffect, useState, } from 'react'
import { useSelector, useDispatch, } from 'react-redux'
import { Helmet, } from "react-helmet"
import { appName, } from '../../../../constants'
import Loading from '../../../layouts/Loading'
import DeletePaymentMethod from './DeletePaymentMethodComponent'
import { getPaymentMethodsList, } from '../../../../redux/actions/getPaymentMethodsActions'
import { deletePaymentMethodAction, } from '../../../../redux/actions/deletePaymentMethodActions'

import "./PaymentMethodsComponent.scss"
import ErrorComponent from '../../../layouts/ErrorComponent'

export default function PaymentMethodsComponent() {
  const [loading, setLoading] = useState(true)

  const [error, setError] = useState("")
  const [deletePaymentMethodModalError, setDeletePaymentMethodModalError] = useState("")
  const [deletePaymentMethodModalLoading, setDeletePaymentMethodModalLoading] = useState(false)

  const dispatch = useDispatch()

  const state = useSelector(state => ({
    auth: state.auth,
    getPaymentMethods: state.getPaymentMethods,
    deletePaymentMethod: state.deletePaymentMethod,
  }))

  useEffect(() => {
    dispatch(getPaymentMethodsList())
  }, [])

  useEffect(() => {
    if (false === state.getPaymentMethods.loading) {
      setLoading(false)
    }
    if (state.getPaymentMethods.error) {
      setError(state.getPaymentMethods.error)
    }
  }, [state.getPaymentMethods])

  useEffect(() => {
    if (false === state.deletePaymentMethod.loading) {
      setLoading(false)
      setDeletePaymentMethodModalLoading(false)
    }
    if (state.deletePaymentMethod.error) {
      setDeletePaymentMethodModalError(
        state.deletePaymentMethod.error
      )
    }
    if (state.deletePaymentMethod.data) {
      dispatch(getPaymentMethodsList())
    }
  }, [state.deletePaymentMethod])

  const onDeletePaymentMethodSubmit = async (paymentMethodID) => {
    setLoading(true)
    setDeletePaymentMethodModalLoading(true)
    dispatch(deletePaymentMethodAction(paymentMethodID))
  }

  function renderPaymentMethods() {
    if (!state.getPaymentMethods.data) {
      return null
    }
    return (
      <div className="accordion" id="payment-methods-accordion">
        {state.getPaymentMethods.data.map(({
          id,
          cardNumber,
          cardHoldersName,
          expiryDate,
        }, index) => (
          <div key={index} className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse"+index} aria-expanded="true" aria-controls="collapseOne">
                Card &#x2022;&#x2022;&#x2022;{cardNumber.slice(-4)}
              </button>
            </h2>
            <div id={"collapse"+index} className="accordion-collapse collapse" data-bs-parent="#payment-methods-accordion">
              <div className="accordion-body">
                <div>Card Holder's Name: {cardHoldersName}</div>
                <div>Expiry Date: {expiryDate}</div>
                <div>CVV: &#x2022;&#x2022;&#x2022;</div>
                <pre>This information is secure.</pre>
                <div className="payment-methods-collapse-btn-container">
                  <DeletePaymentMethod
                    paymentMethodID={id}
                    onSubmit={onDeletePaymentMethodSubmit}
                    error={deletePaymentMethodModalError}
                    loading={deletePaymentMethodModalLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (state.auth.loading || loading) {
    return <>
      <Helmet>
        <title>Payment Methods - {appName}</title>
      </Helmet>
      <div className="container payment-methods-container text-center mt-9 mb-8">
        <Loading />
      </div>
    </>
  }

  return (
    <>
      <Helmet>
        <title>Payment Methods - {appName}</title>
      </Helmet>
      <div className='container payment-methods-container py-7 py-lg-10'>
        <div className="row">
          <div className="col-md-4 offset-md-4">
            <h3 className="lead payment-methods-title">Payment Methods</h3>
              <ErrorComponent error={state.auth.error || error} />
            <a
              href="/user/payment-methods/add"
              className="btn btn-primary joystick-btn"
            >
              ADD NEW PAYMENT METHOD
            </a>
            {renderPaymentMethods()}
          </div>
        </div>
      </div>
    </>       
  )
}
